module.exports = new __parcel__URL__("buckley-coding.e036b89b.png").toString();